import { graphql, Link, useStaticQuery } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import * as React from 'react';
import { MarkdownRemarkNode } from '../../remarkTypes';
import { LandingMeta } from '../PostMeta';

const Articles = () => {
  const data = useStaticQuery(graphql`
    {
      allMarkdownRemark(sort: { frontmatter: { updated: DESC } }) {
        edges {
          node {
            id
            excerpt(pruneLength: 250)
            fields {
              readingTimeMinutes
            }
            frontmatter {
              date
              updated
              title
              slug
              description
              author
              imageAlt
              image {
                childImageSharp {
                  gatsbyImageData(
                    width: 512
                    layout: CONSTRAINED
                    placeholder: BLURRED
                  )
                }
              }
            }
          }
        }
      }
    }
  `);

  const edges = data.allMarkdownRemark.edges as { node: MarkdownRemarkNode }[];

  return (
    <div className="relative bg-gray-100 pt-16 pb-20 px-4 sm:px-6 lg:pt-24 lg:pb-28 lg:px-8">
      <div className="absolute inset-0">
        <div className="bg-gray-100 h-1/3 sm:h-2/3" />
      </div>
      <div className="relative max-w-7xl mx-auto">
        <div className="text-center">
          <h2 className="text-3xl tracking-tight font-extrabold text-gray-900 sm:text-4xl">
            From the blog
          </h2>
          <p className="mt-3 max-w-2xl mx-auto text-xl text-gray-700 sm:mt-4">
            Explore our handy guides for creating efficient seating plans, or
            find fresh inspiration for managing your classroom with a seating
            chart.
          </p>
        </div>
        <div className="mt-12 max-w-lg mx-auto grid gap-5 lg:grid-cols-3 lg:max-w-none">
          {edges
            .map((edge) => edge.node)
            .map((node) => (
              <div
                key={node.id}
                className="flex flex-col rounded-lg shadow-lg overflow-hidden"
              >
                <div className="flex-shrink-0">
                  <GatsbyImage
                    imgClassName="rounded-t-lg"
                    className="h-48 w-full object-cover"
                    image={
                      node.frontmatter.image.childImageSharp.gatsbyImageData
                    }
                    alt={node.frontmatter.imageAlt}
                  />
                </div>
                <div className="flex-1 bg-white p-6 flex flex-col justify-between">
                  <div className="flex-1">
                    <p className="text-sm font-medium text-indigo-600">
                      <span>Article</span>
                    </p>
                    <Link to={node.frontmatter.slug} className="block mt-2">
                      <p className="text-xl font-semibold text-gray-900">
                        {node.frontmatter.title}
                      </p>
                      <p className="mt-3 text-base text-gray-700">
                        {node.frontmatter.description || node.excerpt}
                      </p>
                    </Link>
                  </div>
                  <LandingMeta node={node} />
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default Articles;
